import gql from 'graphql-tag'

export default gql`
  mutation updateVideoTimer($videoTimer: Float!) {
    updateVideoTimer(videoTimer: $videoTimer)
  }
`